import React from "react";
import { Container, Typography, Card, CardContent, List, ListItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import ChecklistIcon from "@mui/icons-material/Checklist";
import SchoolIcon from "@mui/icons-material/School";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";

const AdmissionGuidelines = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      {/* Page Header */}
      <Typography variant="h4" align="center" gutterBottom>
        School Admission Guidelines
      </Typography>

      {/* Admission Process Section */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Admission Process
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon><ChecklistIcon color="primary" /></ListItemIcon>
              <ListItemText primary="Step 1: Fill out the online admission form." />
            </ListItem>
            <ListItem>
              <ListItemIcon><ChecklistIcon color="primary" /></ListItemIcon>
              <ListItemText primary="Step 2: Submit required documents." />
            </ListItem>
            <ListItem>
              <ListItemIcon><ChecklistIcon color="primary" /></ListItemIcon>
              <ListItemText primary="Step 3: Attend the interview/test (if applicable)." />
            </ListItem>
            <ListItem>
              <ListItemIcon><ChecklistIcon color="primary" /></ListItemIcon>
              <ListItemText primary="Step 4: Receive admission confirmation." />
            </ListItem>
          </List>
        </CardContent>
      </Card>

      {/* Required Documents Section */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Required Documents
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
              <ListItemText primary="Birth Certificate" />
            </ListItem>
            <ListItem>
              <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
              <ListItemText primary="Previous Academic Records" />
            </ListItem>
            <ListItem>
              <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
              <ListItemText primary="Address Proof" />
            </ListItem>
            <ListItem>
              <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
              <ListItemText primary="Passport-sized Photographs" />
            </ListItem>
          </List>
        </CardContent>
      </Card>

      {/* Contact Information Section */}
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Contact Information
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon><ContactPhoneIcon color="success" /></ListItemIcon>
              <ListItemText primary="Phone: +91 98765 43210" />
            </ListItem>
            <ListItem>
              <ListItemIcon><ContactPhoneIcon color="success" /></ListItemIcon>
              <ListItemText primary="Email: admissions@school.com" />
            </ListItem>
            <ListItem>
              <ListItemIcon><SchoolIcon color="success" /></ListItemIcon>
              <ListItemText primary="Address: 123, ABC Road, Jaipur, India" />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Container>
  );
};

export default AdmissionGuidelines;
